import { CounterpartyType } from '@/constants/CounterpartyType';
import { Period } from "@/constants/DateTimeConstants";
import { TaxEventStatus } from "@/constants/TaxEventStatus";
import { PaymentStatus } from "@/constants/PaymentConstants";
import { Risk } from "@/constants/Risk";

export enum TaxEventSortField {
    EVENT_DATE = "EVENT_DATE",
    DUE_DATE = "DUE_DATE",
    YEAR = "YEAR",
    PERIOD = "PERIOD",
    AMOUNT = "AMOUNT",
    STATUS = "STATUS",
    PAYMENT_STATUS = "PAYMENT_STATUS",
    RISK = "RISK",
    ASSIGNEE = "ASSIGNEE",
    CREATED_AT = "CREATED_AT",
    UPDATED_AT = "UPDATED_AT"
}

export default class TaxEventFilter {
    // Filters
    dateFrom: string | null = null;
    dateTo: string | null = null;
    isPaid: boolean | null = null;
    taxTypeId: number | null = null;
    customerId: number | null = null;
    customerType: CounterpartyType | null = null;
    createdById: number | null = null;
    lastModifiedById: number | null = null;
    assigneeId: number | null = null;
    year: number | null = null;
    period: Period | null = null;
    status: TaxEventStatus | null = null;
    paymentStatus: PaymentStatus | null = null;
    risk: Risk | null = null;

    // Pagination
    pageNumber = 1; // Frontend pagination usually starts with 1, will subtract 1 manually if needed, wait backend expects 0-indexed page for Pageable.
    pageSize = 20;

    // Sorting
    sortBy: TaxEventSortField = TaxEventSortField.CREATED_AT;
    sortDirection: "ASC" | "DESC" = "DESC";
}
